'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from 'next-auth/react';
import PropTypes from 'prop-types';
import { ReactComponentsProvider } from '../lib/react-components';
import { LaunchDarklyProvider } from '../providers/launchDarklyProvider';

import { theme } from '../constants/theme';

const queryClient = new QueryClient();

const MyApp = ({ Component, pageProps }) => {
  return (
    // eslint-disable-next-line react/prop-types
    <SessionProvider session={pageProps.session}>
      <QueryClientProvider client={queryClient}>
        <LaunchDarklyProvider>
          <ReactComponentsProvider theme={theme}>
            <Component {...pageProps} />
          </ReactComponentsProvider>
        </LaunchDarklyProvider>
      </QueryClientProvider>
    </SessionProvider>
  );
};

MyApp.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: PropTypes.shape({}).isRequired,
};

export default MyApp;
